import { render, staticRenderFns } from "./BezorglijstIndex.vue?vue&type=template&id=0f964862&scoped=true&"
import script from "./BezorglijstIndex.vue?vue&type=script&lang=js&"
export * from "./BezorglijstIndex.vue?vue&type=script&lang=js&"
import style0 from "./BezorglijstIndex.vue?vue&type=style&index=0&id=0f964862&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f964862",
  null
  
)

export default component.exports